export default (s) => {
  return s instanceof Array;
};
